import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, Grid } from 'react-bootstrap';
import EsealLogo from '../../assets/img/eseal-black.png';
import { isEmail, isEmpty, isLength, isContainWhiteSpace } from './validator';
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import SimpleReactValidator from 'simple-react-validator';
import { PostAPI } from "api/post";

let logoValMain = require('../../../src/assets/img/maintenance.png');
const params = new URLSearchParams(window.location.search);
let urlhost = window.location.host;
const domain = urlhost.split('.');
const subDomain = domain[1] +"."+ domain[2];

const ResetPassword = (props) => {
  const { setHasError } = props;
  const [formData, setFormData] = useState({});
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showContent, setShowContent] = useState(false);
  const [showContentExpire, setShowContentExpire] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [dummy, setDummy] = useState(false);
  
  const validator = useRef(new SimpleReactValidator({
    element: (message, className) => (
      <p
        style={{
          color: 'red',
          fontSize: '14px',
          fontWeight: '400px',
          lineHeight: '2'
        }}
      >
        {message}
      </p>
    )
  }));

  const submitReset = async (e) => {
    e.preventDefault(); 
    if (validator.current.allValid()) {
      const data = {
        resetPassword: password,
        confirmPassword: confirmPassword,
        token: params.get('uniqueToken')
      };
    //let url = 'http://sudhakar.esealcom.com:3003/forgot-password/password-reset';
      let url = `https://product-stg.${subDomain}:5003/forgot-password/password-reset`;
      try {
        const res = await PostAPI(url, data);
        if (res.status === 200) {
          if (res.data.data.status === 409) {
            swal({
              title: "Error!",
              text: "Unique Token Already Used!",
              icon: "error",
              timer: 2000,
              button: false
            });
          } else {
            swal({
              title: "Success!",
              text: "Password reset successfully!",
              icon: "success",
              timer: 2000,
              button: false
            });
            props.history.push("/login");
          }
        } else {
          swal({
            title: "Invalid Credentials!",
            icon: "error",
            timer: 2000,
            button: false
          });
        }
      } catch (error) {
        setHasError({
          error: true,
          message: error
        })
      }
    } else {
      validator.current.showMessages();
      setDummy(!dummy);
    }
  };

  const redirectLogin = () => {
    window.location.href = "/login";
  };

  const close1 = () => setShowModal1(false);
  const close = () => setShowModal(false);
  const open1 = () => {
    setShowModal(false);
    setShowModal1(true);
  };
  const open = () => setShowModal(true);

  const useQuery = () => {
    return new URLSearchParams(props.location.search);
  };

  const handleCheckboxChange = useCallback((event) => {
    }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  useEffect(() => {
    let url = `https://login-stg.${subDomain}:3003/forgot-password/token-linkExpiry`;
    let data = {
      token: params.get('uniqueToken')
    };

    const checkTokenExpiry = async () => {
      try {
        const res = await PostAPI(url, data);
        if (res.status === 200) {
          if (res.data.data.status === 409) {
            setShowContent(false);
            setShowContentExpire(true);
          } else {
            setShowContent(true);
            setShowContentExpire(false);
          }
        } else {
          setShowContent(false);
          setShowContentExpire(false);
        }
      } catch (error) {
        setShowContent(false);
        setShowContentExpire(false);
      }
    };

    checkTokenExpiry();
  }, []);

  return (
    <div className="reset-password-container">
      {showContent ? (
        <div className="panel">
           <div className="login-logo">
              <img src={EsealLogo} alt="eSeal Logo" />
            </div>
          <h2>Reset &nbsp; Password</h2>
          <form className="resetPassword-form_fields" onSubmit={submitReset}>
            <div className="resetform-fields">
              <div className="input-fields">
                <i className="password fa fa-lock" aria-hidden="true"></i>
                <input
                  className={password ? 'not-empty' : ''}
                  type="text"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                />
              </div>
              {validator.current.message('Enter new password', password, 'required|min:6|in:' + password)}
            </div>

            <div className="resetform-fields">
              <div className="input-fields">
                <i className="password fa fa-lock" aria-hidden="true"></i>
                <input
                  className={confirmPassword ? 'not-empty' : ''}
                  type="password"
                  placeholder="Re-enter new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  name="confirmPassword"
                />
              </div>
              {validator.current.message(
                'Re-enter new password',
                confirmPassword,
                'required|min:6|in:' + password,
                { messages: { in: 'Passwords need to match!' } }
              )}
            </div>

            <div className='footer-grid' style={{marginTop:"20px"}}>
              <div className='modal__button-container'>
                <button
                  type="button"
                  className="btnCls"
                  onClick={redirectLogin}>Cancel</button>
                <button
                  type="submit"
                  className="btnCls"
                  disabled={false}>Submit</button>
              </div>
            </div>
          </form>
        </div>
      

      ) : (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          {/* <BeatLoader /> */}
        </div>
      )}

      {showContentExpire && (
        <div className="content">
          <Grid fluid>
            <div className="text-center" style={{ margin: '200px', marginTop: '100px !important' }}>
              <img style={{ width: '50px', marginTop: '0px' }} src={logoValMain} alt="logo_image" />
              <h3>Unique Token Expired</h3>
              <h5>You have already used your token for reset password</h5>
              <h5>Please try again by clicking on forgot password of Login</h5>
              <button
                type="button"
                className="btnCls"
                onClick={redirectLogin}
              >
                Login
              </button>
            </div>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;